import { HttpClient, HttpParams } from "@angular/common/http";
import { SelectItem } from "primeng/api";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { BusinesObject } from "./business-object.model";
import { ReferentialsBaseService } from "./referentials-base.service";

export abstract class InternalReferentialsBaseService<
  T extends BusinesObject,
  ID,
> extends ReferentialsBaseService<T, ID> {
  protected constructor(
    protected httpClient: HttpClient,
    protected baseUrl: string,
  ) {
    super(httpClient, baseUrl);
  }

  retrieveSelectorOptions(httpParams?: HttpParams): Observable<SelectItem[]> {
    const cachedValues = localStorage.getItem(this.baseUrl);
    if (cachedValues) {
      return of(JSON.parse(cachedValues) as SelectItem[]);
    }

    return super
      .retrieveSelectorOptions(httpParams)
      .pipe(
        tap((items) =>
          localStorage.setItem(this.baseUrl, JSON.stringify(items)),
        ),
      );
  }
}
